import { useRecoilState } from "recoil";
import { projectsDataState, serverFileState } from "../recoil";
import { getProject } from "../services/projectService";
import { useQuery } from "react-query";
import { useState } from "react";
import { ITrainData } from "@types";
import { imageFlat } from "../utils/utils";
import { getProjects } from "common-lib";

export const useGetProjects = () => {
  const [projectsData, setProjectsData] = useRecoilState(projectsDataState);

  const { isLoading } = useQuery(
    ["projects"],
    async () => await getProjects(),
    {
      onSuccess: (data) => {
        setProjectsData(data.projects);
      },
    }
  );

  return {
    projectsData,
    isProjectsLoading: isLoading,
  };
};

interface useGetProjectProps {
  id: number;
}

export const useGetProject = ({ id }: useGetProjectProps) => {
  const [serverFiles, setServerFiles] = useRecoilState(serverFileState);
  const [projectData, setProjectData] = useState([]);

  const { isLoading } = useQuery(
    ["projects"],
    async () => await getProject(Number(id)),
    {
      onSuccess: (data) => {
        setProjectData(data.project);
        const paths = imageFlat(data.project.images).map(
          (image: { path: string }) => image.path
        );
        setServerFiles(paths);
      },
    }
  );

  return {
    projectData,
    isProjectLoading: isLoading,
  };
};
